/* IMM Look v2 - small, dependency-free behaviours. No tracking, no third-party calls. */
(function () {
  'use strict';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Mobile navigation */
  var burger = qs('[data-imm-burger]');
  var mnav = qs('[data-imm-mnav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  /* Close header dropdowns on outside click */
  document.addEventListener('click', function (e) {
    qsa('.imm-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Pre-fill the RFQ form from ?product= (product page CTA) */
  qsa('[data-imm-prefill]').forEach(function (input) {
    try {
      var params = new URLSearchParams(window.location.search);
      var key = input.getAttribute('data-imm-prefill') || 'product';
      var val = params.get(key);
      if (val && !input.value) {
        input.value = val;
        var field = input.closest('.imm-field');
        if (field) field.classList.add('is-prefilled');
      }
    } catch (err) { /* ignore */ }
  });

  /* Quantity steppers */
  qsa('[data-imm-qty]').forEach(function (wrap) {
    var input = qs('input', wrap);
    if (!input) return;
    qsa('button', wrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step') || '1', 10);
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        if (next < min) next = min;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Cart: submit the form when a quantity changes */
  qsa('[data-imm-cart-form] input[name^="updates"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* Product: variant selection, price + availability, quote link */
  qsa('[data-imm-product]').forEach(function (root) {
    var dataEl = qs('[data-imm-variants]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var selects = qsa('[data-imm-option]', root);
    var idInput = qs('input[name="id"]', root);
    var priceEl = qs('[data-imm-price]', root);
    var compareEl = qs('[data-imm-compare]', root);
    var addBtn = qs('[data-imm-add]', root);
    var availEl = qs('[data-imm-availability]', root);
    var skuEl = qs('[data-imm-sku]', root);
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.'));
    }

    function currentVariant() {
      if (!selects.length) return variants[0];
      var chosen = selects.map(function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function update() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-text-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-text-add') || 'Add to cart') : (addBtn.getAttribute('data-text-soldout') || 'Sold out');
      }
      if (availEl) {
        availEl.textContent = availEl.getAttribute(v.available ? 'data-text-in' : 'data-text-out') || '';
        availEl.setAttribute('data-state', v.available ? 'in' : 'out');
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* ignore */ }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });

    /* Gallery thumbnails */
    var mainImg = qs('[data-imm-gallery-main] img', root);
    qsa('[data-imm-thumb]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = btn.getAttribute('data-src');
        mainImg.srcset = btn.getAttribute('data-srcset') || '';
        mainImg.alt = btn.getAttribute('data-alt') || '';
        qsa('[data-imm-thumb]', root).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Product description tabs */
  qsa('[data-imm-tabs]').forEach(function (tabs) {
    var buttons = qsa('[role="tab"]', tabs);
    var panels = qsa('[role="tabpanel"]', tabs.parentNode);
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.hidden = true; });
        btn.setAttribute('aria-selected', 'true');
        var target = document.getElementById(btn.getAttribute('aria-controls'));
        if (target) target.hidden = false;
      });
    });
  });

  /* Collection: sort select submits, filter toggle on mobile */
  qsa('[data-imm-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  var ftoggle = qs('[data-imm-filter-toggle]');
  var filters = qs('[data-imm-filters]');
  if (ftoggle && filters) {
    ftoggle.addEventListener('click', function () {
      var open = filters.classList.toggle('is-open');
      ftoggle.setAttribute('aria-expanded', String(open));
    });
  }
  qsa('[data-imm-filter-form] input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () { cb.form.submit(); });
  });

  /* Hero product carousel: scroll-snap track + prev/next, dots, keyboard, autoplay */
  qsa('[data-imm-carousel]').forEach(function (root) {
    var track = qs('[data-imm-carousel-track]', root);
    if (!track) return;
    var slides = qsa('[data-imm-slide]', track);
    var dots = qsa('[data-imm-carousel-dot]', root);
    var prev = qs('[data-imm-carousel-prev]', root);
    var next = qs('[data-imm-carousel-next]', root);
    var count = slides.length;
    if (count < 2) return;
    var index = 0;
    var timer = null;
    var paused = false;
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) { /* ignore */ }
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);

    function setCurrent(i) {
      index = i;
      dots.forEach(function (d, n) {
        if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      /* Off-screen slides are inert: not focusable, hidden from screen readers */
      slides.forEach(function (s, n) {
        if (n === i) s.removeAttribute('inert'); else s.setAttribute('inert', '');
      });
    }

    /* While a button/autoplay scroll animates, ignore intermediate scroll positions */
    var lock = false;
    var lockTimer = null;
    function holdLock() {
      lock = true;
      window.clearTimeout(lockTimer);
      lockTimer = window.setTimeout(function () { lock = false; }, 200);
    }

    function goTo(i) {
      i = (i + count) % count;
      holdLock();
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'instant' : 'smooth' });
      setCurrent(i);
    }

    /* Keep dots in sync with swipes / native scrolling */
    var syncTimer = null;
    track.addEventListener('scroll', function () {
      if (lock) { holdLock(); return; }
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== index && i >= 0 && i < count) setCurrent(i);
      }, 80);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { goTo(n); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
    });

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!delay || reduce || paused) return;
      timer = window.setInterval(function () { goTo(index + 1); }, delay);
    }
    function pause() { paused = true; stop(); }
    function resume() { paused = false; start(); }
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', function () { if (!root.contains(document.activeElement)) resume(); });
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget) && !root.matches(':hover')) resume(); });
    root.addEventListener('touchstart', pause, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

    setCurrent(0);
    start();
  });
})();

/* R2: sticky product action bar - shows once the buy/quote box has scrolled above the viewport */
(function () {
  var bar = document.querySelector('[data-imm-pbar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var target = document.getElementById(bar.getAttribute('data-target')) || document.getElementById('quote-box') || document.querySelector('.imm-buy');
  if (!target) return;
  var go = bar.querySelector('[data-imm-pbar-go]');
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var on = !e.isIntersecting;
    bar.classList.toggle('is-on', on);
    document.body.classList.toggle('imm-pbar-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (go) go.tabIndex = on ? 0 : -1;
  }).observe(target);
  if (go) go.addEventListener('click', function (ev) {
    ev.preventDefault();
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    target.classList.remove('is-flash'); void target.offsetWidth; target.classList.add('is-flash');
    var f = target.querySelector('input[type=email], button[type=submit]');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 450);
  });
})();

/* Loop 2 R10b: one "who sent this post" mechanism for every theme contact form (replaces the per-form flags
   imm_quote_sent / imm_rsc_sent / imm_exit_sent). Shopify marks EVERY contact form on the page as posted (and
   repeats the errors in each), so the submitter is recorded in sessionStorage imm_qsent_pend at submit time
   (capture phase); a submit from any other POST contact form clears it (10c: GET forms such as the header search
   and the hCaptcha challenge page never clear it). Consumers: R3 drawer below, R18 exit prompt,
   assets/imm-drawer.js (R4), assets/imm-rescue.js (R6), assets/imm-qmemory.js (R11).
   window.immPend   = the pending marker found on this load ({s: list|product|rescue|exit, n, t}) or null
   window.immPostedBy = its source when this load is the success page (?contact_posted=true), else '' */
(function () {
  var PEND = 'imm_qsent_pend', posted = /contact_posted=true/.test(location.search), p = null;
  var SRC = { 'quote-list-form': 'list', 'product-quote-form': 'product', 'imm-rsc-form': 'rescue', 'exit-quote-form': 'exit' };
  try { p = JSON.parse(sessionStorage.getItem(PEND)); } catch (e) {}
  if (p && ['list', 'product', 'rescue', 'exit'].indexOf(p.s) < 0) p = null;
  if (posted && p) { try { sessionStorage.removeItem(PEND); } catch (e) {} }
  window.immPend = p;
  window.immPosted = posted && p ? p : null;
  window.immPostedBy = window.immPosted ? p.s : '';
  window.immQuoteSent = !!(p && p.s === 'list');   // R4 name kept: the drawer form sent this post / these errors
  document.addEventListener('submit', function (e) {
    var f = e.target, s = SRC[f.id], o = null;
    if (s) {
      o = { s: s };
      if (s === 'list') { var l = null; try { l = JSON.parse(localStorage.getItem('imm_quote')); } catch (x) {} o.n = Array.isArray(l) ? l.length : 0; }
      if (s === 'product') { var h = document.querySelector('.imm-product h1'); o.n = 1; o.t = h ? h.textContent.trim().slice(0, 120) : ''; }
    }
    if (!o) {
      var challenge = /^\/challenge/.test(location.pathname) || document.body.classList.contains('template-captcha');
      var post = String(f.getAttribute('method') || f.method || '').toLowerCase() === 'post';
      var contact = !!f.querySelector('input[name="form_type"][value="contact"]') || /\/contact(\b|$)/.test(f.getAttribute('action') || '');
      if (challenge || !post || !contact) return;
    }
    try { if (o) sessionStorage.setItem(PEND, JSON.stringify(o)); else sessionStorage.removeItem(PEND); } catch (x) {}
  }, true);
  // Remove (10c: not just hide, so [data-imm-qsent] checks in render(), below and in imm-drawer.js see the truth) the
  // success alert (after a post) or the error alert (after a failed post) in the theme forms that did not send it.
  // Untracked forms (e.g. snippets/rfq-form.liquid) keep Shopify's own output.
  var mine = posted ? window.immPostedBy : (p ? p.s : '');
  var cls = posted ? '.imm-alert--ok' : '.imm-alert--err';
  if (!posted && !p) return;
  Object.keys(SRC).forEach(function (id) {
    var f = document.getElementById(id);
    if (!f || SRC[id] === mine) return;
    var a = f.querySelectorAll(cls);
    for (var i = a.length - 1; i >= 0; i--) a[i].remove();
  });
})();

/* R3: quote list (RFQ cart). localStorage key imm_quote; the drawer form posts every line in contact[items]. */
(function () {
  var KEY = 'imm_quote';
  var qd = document.querySelector('[data-imm-qd]');
  if (!qd) return;
  var list = qd.querySelector('[data-imm-qlist]');
  var empty = qd.querySelector('[data-imm-qempty]');
  var form = qd.querySelector('[data-imm-qform]');
  var items = qd.querySelector('[data-imm-qitems]');
  var toast = document.querySelector('[data-imm-toast]');
  var lastFocus = null, toastTimer;

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} render(); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(p) { var n = Number(String(p).replace(/,/g, '')); return isNaN(n) ? '' : '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  window.immFmt = fmt;
  function say(msg, ms) {   // R16: optional duration (undo toast stays 5 s)
    if (!toast) return;
    toast.innerHTML = msg; toast.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, ms || 3200);
  }
  // R16: drawer polish helpers. live = polite announcer for moves; refocus = put keyboard focus back after a re-render.
  var live = document.createElement('p'); live.className = 'imm-visually-hidden'; live.setAttribute('aria-live', 'polite');
  qd.querySelector('.imm-qd__panel').appendChild(live);
  function refocus(q) { var el = list.querySelector(q); if (el) el.focus(); return el; }
  var undoIt = null;
  function undo(kb) {   // R18: kb = keyboard activation -> focus the qty box; pointer -> the remove button (no mobile keyboard)
    if (!undoIt || Date.now() - undoIt.t > 6000) return false;
    var a = load(), it = undoIt.it, ix = Math.min(undoIt.ix, a.length);
    undoIt = null;
    if (!it.u || !a.some(function (x) { return x.u === it.u; })) a.splice(ix, 0, it);
    save(a);
    if (toast) { clearTimeout(toastTimer); toast.classList.remove('is-on'); }
    live.textContent = 'Restored ' + it.t;
    refocus(kb ? '[data-i="' + ix + '"]' : '[data-rm="' + ix + '"]');
    return true;
  }
  function move(i, d) {
    var a = load(), j = i + d;
    if (!a[i] || j < 0 || j >= a.length) return;
    var x = a[i]; a[i] = a[j]; a[j] = x;
    save(a);
    live.textContent = x.t + ' moved to position ' + (j + 1) + ' of ' + a.length;
    return j;
  }
  // R16: empty drawer shows up to 4 recently viewed products (localStorage imm_rv, R10) with + Add to quote
  function rvShortcuts() {
    var box = empty.querySelector('[data-imm-qrv]');
    if (!box) { empty.insertAdjacentHTML('beforeend', '<div class="imm-qd__rv" data-imm-qrv hidden></div>'); box = empty.querySelector('[data-imm-qrv]'); }
    var rv; try { rv = JSON.parse(localStorage.getItem('imm_rv')) || []; } catch (e) { rv = []; }
    rv = rv.filter(function (x) { return x && x.u && x.t; }).slice(0, 4);
    box.hidden = !rv.length;
    box.innerHTML = rv.length ? '<p class="imm-qd__rv-h">Recently viewed</p><ul>' + rv.map(function (x) {
      return '<li>' + (x.i ? '<img src="' + esc(x.i) + '" width="40" height="40" alt="" loading="lazy">' : '<span class="imm-qd__ph"></span>') +
        '<a href="' + esc(x.u) + '">' + esc(x.t) + '</a>' +
        '<button type="button" class="imm-qd__rv-add" data-imm-qadd data-t="' + esc(x.t) + '" data-u="' + esc(x.u) + '" data-i="' + esc(x.i) + '" data-v="' + esc(x.v) + '" data-p="' + esc(x.p) + '" aria-label="Add ' + esc(x.t) + ' to the quote list">+ Add</button></li>';
    }).join('') + '</ul>' : '';
  }
  window.immToast = say;

  function render() {
    var a = load(), n = a.length;
    document.querySelectorAll('[data-imm-qbadge]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
    qd.querySelectorAll('[data-imm-qcount]').forEach(function (c) { c.textContent = n; });
    var lab = qd.querySelector('[data-imm-qcount-label]'); if (lab) lab.textContent = n ? '(' + n + ')' : '';
    var sentMsg = n === 0 && qd.querySelector('[data-imm-qsent]');
    empty.hidden = n > 0 || !!sentMsg;
    if (n === 0 && !sentMsg) rvShortcuts();
    form.hidden = n === 0 && !sentMsg;
    form.classList.toggle('is-sent', !!sentMsg);   // after a successful post show only the thanks message
    list.innerHTML = a.map(function (it, i) {
      return '<li class="imm-qd__item">' +
        (it.i ? '<img src="' + esc(it.i) + '" width="56" height="56" alt="" loading="lazy">' : '<span class="imm-qd__ph"></span>') +
        '<div class="imm-qd__meta"><span class="imm-qd__brand">' + esc(it.v) + '</span>' + (it.u ? '<a href="' + esc(it.u) + '">' + esc(it.t) + '</a>' : '<span class="imm-qd__free">' + esc(it.t) + '</span>') +
        (it.p ? '<span class="imm-qd__price">' + fmt(it.p) + '</span>' : '') + '</div>' +
        '<label class="imm-qd__qty"><span class="imm-visually-hidden">Quantity</span><input type="number" min="1" value="' + (it.q || 1) + '" data-i="' + i + '" inputmode="numeric"></label>' +
        '<button type="button" class="imm-qd__rm" data-rm="' + i + '" aria-label="Remove ' + esc(it.t) + '">&times;</button>' +
        // Loop 2 R7: optional note per line (it.n), sent with the line
        '<details class="imm-qd__ln"' + (it.n ? ' open' : '') + '><summary>' + (it.n ? 'Line note' : '+ Add a note for this line') + '</summary>' +
        '<label><span class="imm-visually-hidden">Note for ' + esc(it.t) + '</span><input type="text" maxlength="200" value="' + esc(it.n) + '" data-n="' + i + '" placeholder="e.g. with test leads, alternative OK, deliver with batch 2"></label></details>' +
        // R16: reorder (also Alt + Arrow Up / Down anywhere in the line)
        (n > 1 ? '<div class="imm-qd__mv" role="group" aria-label="Order of ' + esc(it.t) + '">' +
          '<button type="button" data-mv="-1" data-mvi="' + i + '" aria-label="Move up" aria-keyshortcuts="Alt+ArrowUp"' + (i === 0 ? ' disabled' : '') + '>&uarr;</button>' +
          '<button type="button" data-mv="1" data-mvi="' + i + '" aria-label="Move down" aria-keyshortcuts="Alt+ArrowDown"' + (i === n - 1 ? ' disabled' : '') + '>&darr;</button></div>' : '') + '</li>';
    }).join('');
    document.querySelectorAll('[data-imm-qadd]').forEach(function (b) {
      var inList = a.some(function (it) { return it.u === b.getAttribute('data-u'); });
      b.classList.toggle('is-in', inList);
      if (!b.dataset.label) b.dataset.label = b.textContent;
      b.textContent = inList ? '✓ In quote list' : b.dataset.label;
    });
  }
  window.immQuoteRender = render;

  // Meta AddToCart for quote-list adds (2026-11-02): custom pixel "IMM Meta Lead (quote)" subscribes to imm_add_to_quote.
  // Fires only when a [data-imm-qadd] click newly pushes a product into imm_quote (not on restore, qty edits,
  // already-in-list clicks, the cart form or cart->quote, whose items were real cart adds). Ids from /products/<handle>.js.
  function immPublishQuoteAdd(u) {
    if (!(window.Shopify && Shopify.analytics && Shopify.analytics.publish)) return;
    var handle = String(u || '').split(/[?#]/)[0].split('/products/')[1];
    if (!handle) return;
    var vm = /[?&]variant=(\d+)/.exec(String(u || ''));
    fetch('/products/' + handle.split('/')[0] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p || !p.id) return;
      var vs = p.variants || [], v = null, k;
      for (k = 0; k < vs.length && !v; k++) if (vm && String(vs[k].id) === vm[1]) v = vs[k];
      for (k = 0; k < vs.length && !v; k++) if (vs[k].available) v = vs[k];
      v = v || vs[0] || {};
      Shopify.analytics.publish('imm_add_to_quote', {
        product_id: String(p.id), variant_id: v.id ? String(v.id) : '', sku: v.sku || '', title: p.title || '',
        price: (Number(v.price != null ? v.price : p.price) / 100) || 0,
        currency: (Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }).catch(function () {});
  }

  function open() {
    lastFocus = document.activeElement;
    qd.hidden = false; document.documentElement.classList.add('imm-noscroll');
    requestAnimationFrame(function () { qd.classList.add('is-open'); });
    var f = qd.querySelector('.imm-qd__x'); if (f) f.focus();
  }
  function close() {
    qd.classList.remove('is-open'); document.documentElement.classList.remove('imm-noscroll');
    setTimeout(function () { qd.hidden = true; }, 250);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-imm-qadd]');
    if (add) {
      e.preventDefault();
      var a = load(), u = add.getAttribute('data-u');
      if (a.some(function (it) { return it.u === u; })) { open(); return; }
      a.push({ t: add.getAttribute('data-t'), u: u, i: add.getAttribute('data-i'), v: add.getAttribute('data-v'), p: add.getAttribute('data-p'), q: 1 });
      save(a);
      immPublishQuoteAdd(u);
      say('Added to your quote list &middot; <button type="button" data-imm-qopen>View list (' + a.length + ')</button>');
      if (qd.contains(add)) refocus(e.detail === 0 ? '[data-i="' + (a.length - 1) + '"]' : '[data-rm="' + (a.length - 1) + '"]');   // R16/R18: empty-state shortcuts; qty box only for keyboard
      return;
    }
    if (e.target.closest('[data-imm-qopen]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-imm-qclose]')) { close(); return; }
    if (e.target.closest('[data-imm-qundo]')) { undo(e.detail === 0); return; }
    var mv = e.target.closest('[data-mv]');
    if (mv) {
      var d = +mv.getAttribute('data-mv'), j = move(+mv.getAttribute('data-mvi'), d);
      if (j !== undefined) { var f = refocus('[data-mv="' + d + '"][data-mvi="' + j + '"]'); if (f && f.disabled) refocus('[data-mv="' + (-d) + '"][data-mvi="' + j + '"]'); }
      return;
    }
    var rm = e.target.closest('[data-rm]');
    if (rm) {   // R16: undo for 5 s in the toast (Ctrl/Cmd+Z in the drawer too); focus stays in the list
      var b = load(), ix = +rm.getAttribute('data-rm'), gone = b.splice(ix, 1)[0];
      if (!gone) return;
      save(b);
      undoIt = { it: gone, ix: ix, t: Date.now() };
      say('Removed ' + esc(gone.t.length > 48 ? gone.t.slice(0, 46) + '…' : gone.t) + ' &middot; <button type="button" data-imm-qundo>Undo</button>', 5000);
      if (!refocus('[data-rm="' + Math.min(ix, b.length - 1) + '"]')) { var x = qd.querySelector('.imm-qd__x'); if (x) x.focus(); }
    }
  });
  list.addEventListener('change', function (e) {
    var n = e.target.getAttribute('data-n');
    if (n !== null) {   // R10b: store without a full re-render so keyboard focus stays where the buyer is
      var c = load(); if (!c[n]) return;
      c[n].n = e.target.value.trim().slice(0, 200);
      try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (x) {}
      var sm = e.target.closest('details'); sm = sm && sm.querySelector('summary');
      if (sm) sm.textContent = c[n].n ? 'Line note' : '+ Add a note for this line';
      return;
    }
    var i = e.target.getAttribute('data-i'); if (i === null) return;
    var had = document.activeElement === e.target;
    var a = load(); if (a[i]) { a[i].q = Math.min(9999, Math.max(1, parseInt(e.target.value, 10) || 1)); save(a); if (had) refocus('[data-i="' + i + '"]'); }
  });
  list.addEventListener('keydown', function (e) {   // Enter in a line note saves it instead of sending the form
    if (e.key === 'Enter' && e.target.hasAttribute('data-n')) { e.preventDefault(); e.target.blur(); return; }
    if (e.key === 'Enter' && e.target.hasAttribute('data-i')) { e.preventDefault(); e.target.dispatchEvent(new Event('change', { bubbles: true })); return; }
    if (e.altKey && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {   // R16: Alt + Arrow moves the focused line
      var li = e.target.closest('.imm-qd__item'); if (!li) return;
      e.preventDefault();
      var idx = Array.prototype.indexOf.call(list.children, li), cls = e.target.hasAttribute('data-i') ? 'data-i' : e.target.hasAttribute('data-n') ? 'data-n' : '';
      var j = move(idx, e.key === 'ArrowUp' ? -1 : 1);
      if (j === undefined) return;
      if (!cls || !refocus('[' + cls + '="' + j + '"]')) refocus('.imm-qd__item:nth-child(' + (j + 1) + ') [data-rm]');
    }
  });
  document.addEventListener('keydown', function (e) {   // R16: Ctrl/Cmd+Z right after a remove restores the line
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey && (e.key === 'z' || e.key === 'Z') && !qd.hidden && undoIt && !/INPUT|TEXTAREA/.test(document.activeElement && document.activeElement.tagName || '')) {
      if (undo(true)) e.preventDefault();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qd.hidden) close(); });
  form.addEventListener('submit', function () {
    items.value = load().map(function (it, i) {
      return (i + 1) + '. ' + (it.q || 1) + ' x ' + it.t + (it.p ? ' (list $' + it.p + ')' : '') + (it.u ? ' - ' + location.origin + it.u : ' - part number, not in online catalogue') + (it.n ? '\n   Note: ' + it.n : '');
    }).join('\n');
  });

  render();
  // After a successful post Shopify reloads the page with ?contact_posted=true (submitter: R10b block above)
  if (window.immPostedBy === 'list') {
    try { localStorage.removeItem(KEY); } catch (e) {}
    render(); open();
    if (!qd.querySelector('[data-imm-qsent]')) {
      empty.innerHTML = '<p><b>Thanks. Your quote request is in.</b></p><p>We typically reply within one working day.</p>';
    }
  }
})();

/* R4: instant search. Storefront search hides seo.hidden products, so the theme keeps its own index:
   /collections/all?view=idx&page=N (templates/collection.idx.liquid), cached in localStorage for 12 h. */
(function () {
  var KEY = 'imm_idx_v2', TTL = 12 * 3600 * 1000, idxPromise = null;
  var quoteUrl = (document.documentElement.getAttribute('data-quote-url') || '/pages/contact');

  function getJSON(u, tries) {
    return fetch(u, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (t) { return fixImg(JSON.parse(t)); }, function (err) {
      if ((tries || 0) < 2) return new Promise(function (res) { setTimeout(res, 900 * ((tries || 0) + 1)); }).then(function () { return getJSON(u, (tries || 0) + 1); });
      throw err;
    });
  }
  /* Load a whole collection index, 3 pages at a time. Resolves { d, complete }. */
  function loadIdx(url) {
    var J = url.indexOf('?') > -1 ? '&' : '?';   // R18: vendor pages (/collections/vendors?q=X) already carry a query
    return getJSON(url + J + 'view=idx&page=1').then(function (first) {
      var all = first.d.slice(), pages = [], ok = true;
      for (var i = 2; i <= first.n; i++) pages.push(i);
      function worker() {
        if (!pages.length) return Promise.resolve();
        var n = pages.shift();
        return getJSON(url + J + 'view=idx&page=' + n).then(function (pg) { all = all.concat(pg.d); }, function () { ok = false; }).then(worker);
      }
      return Promise.all([worker(), worker(), worker()]).then(function () { return { d: all, complete: ok && all.length >= first.t }; });
    });
  }
  window.immLoadIdx = loadIdx;
  // the index stores image paths relative to /cdn/shop/ to keep it small
  function fixImg(pg) { pg.d.forEach(function (p) { if (p[4] && p[4].charAt(0) !== '/' && p[4].indexOf('http') !== 0) p[4] = '/cdn/shop/' + p[4]; }); return pg; }
  window.immFixIdx = fixImg;
  function getIndex() {
    if (idxPromise) return idxPromise;
    try {
      var c = JSON.parse(localStorage.getItem(KEY));
      if (c && Date.now() - c.ts < TTL && c.d && c.d.length) { idxPromise = Promise.resolve(c.d); return idxPromise; }
    } catch (e) {}
    idxPromise = loadIdx('/collections/all').then(function (r) {
      if (r.complete) { try { localStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), d: r.d })); } catch (e) {} }
      else idxPromise = null;   // partial: use it now, retry on the next call
      return r.d;
    }).catch(function () { idxPromise = null; return []; });
    return idxPromise;
  }
  window.immGetIndex = getIndex;

  /* Loop 2 R1: part-number tolerant matching. Every query token must hit the word haystack OR the
     separator-stripped haystack ("87V" = "87-V" = "87 V"; "875" finds "87-5"). If nothing matches, a leading
     2-4 letter ordering prefix is dropped ("FLK-87-5" -> "875"). Exact model / SKU hits rank first.
     immModel() is the model token parsed from the title (shown as "Model", empty when none is found). */
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9.+]+/g, ' ').trim(); }
  function cmp(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  var UNIT = /^(kg|g|mg|µg|lb|lbs|oz|t|v|vac|vdc|kv|mv|a|ma|µa|ua|ka|mm|cm|m|km|in|ft|psi|psig|bar|mbar|kpa|mpa|pa|hz|khz|mhz|ghz|w|kw|mw|°c|°f|c|f|k|ω|kω|mω|ohm|ohms|ml|l|%|db|dbm|s|ms|µs|ns|ch|channel|channels|digit|digits|x)$/i;
  var SUFFIX = /^([IVX]{1,3}|MAX|PRO|FC|TR|\d+[A-Z]{0,2}|[A-Z]\d+)$/i;
  function clean(t) { return String(t || '').replace(/[,;:()]+$/, '').replace(/^[(]+/, ''); }
  // Model code parsed from the title: first digit-bearing token (plus a 2-4 capital-letter series prefix such as
  // "EPB 2103i") and up to 2 following suffix tokens ("87V MAX", "28 II", "1587 FC"). A bare number followed by a
  // unit ("210 g", "1000 V") is a spec, not a model. w[0] counts only when it is not the vendor name.
  function model(p) {
    var v = cmp(p[2]), w = String(p[0] || '').split(/\s+/), i, t;
    for (i = 0; i < Math.min(w.length, 5); i++) {
      t = clean(w[i]);
      if (i === 0 && (!t || v.indexOf(cmp(t)) === 0)) continue;
      if (!/\d/.test(t) || !/^[A-Za-z0-9][A-Za-z0-9.\-\/+]*$/.test(t)) continue;
      if (/^\d+(\.\d+)?$/.test(t) && UNIT.test(clean(w[i + 1]))) continue;
      var prev = i > 0 ? w[i - 1] : '';
      if (/^[A-Z]{2,4}$/.test(prev) && v.indexOf(prev.toLowerCase()) !== 0) t = prev + ' ' + t;
      for (var k = i + 1, n = 0; n < 2 && k < w.length; k++, n++) {
        if (/[,;:)]$/.test(w[k - 1])) break;          // "87V MAX, True-RMS": stop at punctuation
        var s = clean(w[k]);
        if (!SUFFIX.test(s) || /^(kit|vip)$/i.test(s)) break;
        if (/^\d+[A-Z]{0,2}$/i.test(s) && (UNIT.test(clean(w[k + 1])) || UNIT.test(s.replace(/^\d+/, '')))) break;
        t += ' ' + s;
      }
      return t;
    }
    return '';
  }
  function prep(p) {
    if (p._h !== undefined) return;
    p._h = norm(p[0] + ' ' + p[2] + ' ' + p[5] + ' ' + (p[6] || ''));
    p._c = cmp(p[0]) + ' ' + cmp(p[6]);
    p._m = model(p); p._mc = cmp(p._m); p._sc = cmp(p[6]);
  }
  function hit(p, toks) {
    for (var j = 0; j < toks.length; j++) {
      if (p._h.indexOf(toks[j]) > -1) continue;
      var c = cmp(toks[j]);
      if (!c || p._c.indexOf(c) === -1) return false;
    }
    return true;
  }
  function winHit(p, cq) {   // cq equals 1-3 consecutive title words joined (Fluke "87 V" -> "87v")
    var w = norm(p[0]).split(' '), best = 0;
    for (var i = 0; i < w.length && best < 2; i++) {
      var s = '';
      for (var k = i; k < Math.min(w.length, i + 3); k++) {
        s += cmp(w[k]);
        if (s === cq) { best = 2; break; }
        if (!best && s.length > cq.length && s.indexOf(cq) === 0) best = 1;
        if (s.length > cq.length) break;
      }
    }
    return best;
  }
  function match(d, q) {
    var toks = norm(q).split(' ').filter(Boolean), out = [], pref = '';
    if (!toks.length) return out;
    function scan(tk) {
      var cq = cmp(tk.join('')), nq = tk.join(' ');
      for (var i = 0; i < d.length; i++) {
        var p = d[i]; prep(p);
        if (!hit(p, tk)) continue;
        var t = norm(p[0]), sc = 0;
        if (cq.length > 1 && (cq === p._mc || cq === p._sc)) sc += 20;
        else if (cq.length > 1 && p._mc.indexOf(cq) === 0) sc += 8;
        var wh = cq.length > 1 ? winHit(p, cq) : 0;
        if (wh === 2) sc += 12; else if (wh === 1) sc += 4;
        else if (tk.length > 1) for (var j = 0; j < tk.length; j++) if (/\d/.test(tk[j]) && winHit(p, cmp(tk[j])) === 2) { sc += 6; break; }
        if (t.indexOf(nq) === 0) sc += 6; else if (t.indexOf(nq) > -1) sc += 3;
        if (norm(p[2]) === tk[0]) sc += 2;
        if (pref && cmp(p[2]).indexOf(pref.charAt(0)) === 0) sc += 3;
        sc -= t.length / 400;
        out.push([sc, p]);
      }
    }
    scan(toks);
    if (!out.length && toks.length > 1 && /^[a-z]{2,4}$/.test(toks[0]) && /[1-9]/.test(toks.slice(1).join(''))) {
      pref = toks[0]; scan(toks.slice(1));
      out = out.filter(function (x) { return x[0] >= 4; });   // prefix dropped: keep only model-like hits
    }
    out.sort(function (a, b) { return b[0] - a[0]; });
    // part-number query with exact model hits: drop loose token-soup matches ("87 V" should not list every 1000 V meter)
    if (out.length && out[0][0] >= 11 && /\d/.test(cmp(q))) out = out.filter(function (x) { return x[0] >= 2.5; });
    return out;
  }
  function search(d, q, limit) {
    var out = match(d, q);
    return { list: out.slice(0, limit).map(function (x) { return x[1]; }), total: out.length };
  }
  window.immSearch = search;
  window.immNorm = norm; window.immCompact = cmp; window.immModel = function (p) { prep(p); return p._m; };
  window.immMatchQ = function (p, q) { prep(p); var t = norm(q).split(' ').filter(Boolean); return !t.length || hit(p, t); };
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  window.immMoney = money;

  document.querySelectorAll('form.imm-search').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    form.classList.add('imm-ps-host');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    var box = document.createElement('div');
    box.className = 'imm-ps'; box.hidden = true; box.setAttribute('role', 'listbox');
    box.id = 'imm-ps-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-controls', box.id);
    form.appendChild(box);
    var timer, active = -1;

    function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
      if (!box.innerHTML) box.innerHTML = '<div class="imm-ps__msg">Searching 6,000+ instruments&hellip;</div>';
      getIndex().then(function (d) {
        if (input.value.trim() !== q) return;
        var r = search(d, q, 6);
        var html = '';
        if (r.total) {
          html += '<div class="imm-ps__head">' + r.total + ' match' + (r.total === 1 ? '' : 'es') + '</div>';
          html += r.list.map(function (p) {
            return '<a class="imm-ps__item" role="option" href="/products/' + esc(p[1]) + '">' +
              (p[4] ? '<img src="' + esc(p[4]) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="imm-ps__ph"></span>') +
              '<span class="imm-ps__t"><small>' + esc(p[2]) + (p._m ? ' &middot; Model <b class="imm-ps__m">' + esc(p._m) + '</b>' : '') + '</small>' + esc(p[0]) + '</span>' +
              '<span class="imm-ps__p">' + money(p[3]) + '</span></a>';
          }).join('');
          html += '<a class="imm-ps__all" role="option" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all ' + r.total + ' results &rarr;</a>';
        } else if (!d.length) {
          html += '<a class="imm-ps__all" role="option" href="/search?q=' + encodeURIComponent(q) + '&type=product">Search for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
        } else {
          html += '<div class="imm-ps__msg"><b>Not in the online catalogue yet.</b> We source 15+ brands on request.</div>' +
            '<a class="imm-ps__all imm-ps__all--quote" role="option" href="' + quoteUrl + '?product=' + encodeURIComponent(q) + '">Ask us to quote &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
        }
        box.innerHTML = html; active = -1;
      });
    }
    input.addEventListener('focus', function () { getIndex(); if (input.value.trim().length > 1) run(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 110); });
    input.addEventListener('keydown', function (e) {
      var opts = box.hidden ? [] : box.querySelectorAll('[role="option"]');
      if (e.key === 'Escape') { hide(); return; }
      if (!opts.length || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      if (e.key === 'Enter') { if (active > -1) { e.preventDefault(); location.href = opts[active].href; } return; }
      e.preventDefault();
      active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
      opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); o.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  });

  /* Search page: storefront search returned nothing -> render matches from the index */
  var fb = document.querySelector('[data-imm-search-fallback]');
  if (fb) {
    var q = fb.getAttribute('data-q');
    getIndex().then(function (d) {
      var r = search(d, q, 48);
      if (!r.total) { fb.hidden = true; var e = document.querySelector('[data-imm-search-empty]'); if (e) e.hidden = false; return; }
      var h1 = document.querySelector('.imm-search-page h1');
      if (h1) h1.textContent = r.total + ' result' + (r.total === 1 ? '' : 's') + ' for “' + q + '”';
      fb.querySelector('[data-imm-search-grid]').innerHTML = r.list.map(function (p) {
        return '<article class="imm-card imm-prod"><button type="button" class="imm-prod__cmp" data-imm-cmp aria-pressed="false" data-t="' + esc(p[0]) + '" data-u="/products/' + esc(p[1]) + '" data-i="' + esc(p[4]) + '" data-v="' + esc(p[2]) + '" data-p="' + Number(p[3]).toFixed(2) + '">Compare</button><div class="imm-prod__media">' +
          (p[4] ? '<img src="' + esc(p[4].replace('width=160', 'width=600')) + '" width="600" height="600" loading="lazy" alt="' + esc(p[0]) + '">' : '') +
          '</div><span class="imm-prod__brand">' + esc(p[2]) + '</span>' +
          '<h3 class="imm-prod__title"><a href="/products/' + esc(p[1]) + '">' + esc(p[0]) + '</a></h3>' +
          '<div class="imm-prod__price">' + money(p[3]) + ' <small class="imm-prod__cur">USD</small></div>' +
          '<div class="imm-prod__foot"><span class="imm-prod__stock"><i></i>' + 'Typical reply: 1 working day' + '</span>' +
          '<a class="imm-prod__quote" href="' + quoteUrl + '?product=' + encodeURIComponent(p[0]) + '" data-imm-qadd data-t="' + esc(p[0]) + '" data-u="/products/' + esc(p[1]) + '" data-i="' + esc(p[4]) + '" data-v="' + esc(p[2]) + '" data-p="' + Number(p[3]).toFixed(2) + '">+ Add to quote</a></div></article>';
      }).join('');
      var more = fb.querySelector('[data-imm-search-more]');
      if (more && r.total > 48) { more.hidden = false; more.textContent = 'Showing 48 of ' + r.total + '. Add a model number or brand to narrow it down.'; }
      fb.hidden = false;
      if (window.immQuoteRender) window.immQuoteRender();
    });
  }
})();

/* R5: mega menu opens on hover (fine pointers) and on click/keyboard via <details> */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('[data-imm-mega]').forEach(function (li) {
    var d = li.querySelector('details'), t;
    function place() { var h = document.querySelector('[data-imm-header]'); if (h) document.documentElement.style.setProperty('--imm-mega-top', Math.max(0, h.getBoundingClientRect().bottom) + 'px'); }
    d.addEventListener('toggle', place);
    li.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t); d.setAttribute('open', ''); });
    li.addEventListener('mouseleave', function () { if (!mq.matches) return; t = setTimeout(function () { d.removeAttribute('open'); }, 160); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { d.removeAttribute('open'); d.querySelector('summary').focus(); } });
  });
})();

/* R6: help launcher */
(function () {
  var h = document.querySelector('[data-imm-help]');
  if (!h) return;
  var btn = h.querySelector('[data-imm-help-btn]'), panel = h.querySelector('.imm-help__panel');
  function set(open) {
    h.classList.toggle('is-open', open); panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    btn.setAttribute('aria-label', open ? 'Close help' : 'Questions? Contact options');
  }
  set(false);
  btn.addEventListener('click', function () { set(panel.hidden); if (!panel.hidden) { var f = panel.querySelector('a'); if (f) f.focus(); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { set(false); btn.focus(); } });
  document.addEventListener('click', function (e) { if (!h.contains(e.target) && !panel.hidden) set(false); });
})();

/* R7: instant collection filter (brand chips, price bands, text; Loop 2 R14: product-type chips). Native storefront filters are not available,
   so the collection's products come from the same compact index template: <collection>?view=idx&page=N */
(function () {
  var box = document.querySelector('[data-imm-if]');
  if (!box) return;
  var url = box.getAttribute('data-url'), quoteUrl = document.documentElement.getAttribute('data-quote-url') || '/pages/contact';
  var server = document.querySelector('[data-imm-coll-server]'), res = document.querySelector('[data-imm-if-results]');
  var grid = res.querySelector('[data-imm-if-grid]'), more = res.querySelector('[data-imm-if-more]');
  var qIn = box.querySelector('[data-imm-if-q]'), bWrap = box.querySelector('[data-imm-if-brands]'), pWrap = box.querySelector('[data-imm-if-price]'), tWrap = box.querySelector('[data-imm-if-types]'), status = box.querySelector('[data-imm-if-status]');
  var data = null, state = { q: '', brands: [], band: -1, types: [] }, shown = 48, timer, TYPES = [];
  var T_MIN = 3, T_TOP = 10;   // R14: a type needs >= 3 products in this collection; 10 chips, the rest in a select
  var BANDS = [['Under $500', 0, 500], ['$500 - $2,000', 500, 2000], ['$2,000 - $10,000', 2000, 10000], ['$10,000+', 10000, 1e12]];
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9.+]+/g, ' ').trim(); }

  function load() {
    if (data) return Promise.resolve(data);
    if (url === '/collections/all' && window.immGetIndex) return window.immGetIndex().then(function (d) { data = d; return d; });
    var key = 'imm_cidx2_' + url;
    try { var c = JSON.parse(sessionStorage.getItem(key)); if (c) { data = c; return Promise.resolve(c); } } catch (e) {}
    return window.immLoadIdx(url).then(function (r) {
      data = r.d;
      if (r.complete) { try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {} }
      return data;
    });
  }

  function chips() {
    var counts = {};
    data.forEach(function (p) { if (p[2]) counts[p[2]] = (counts[p[2]] || 0) + 1; });
    var vendors = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
    if (vendors.length > 1) {
      bWrap.innerHTML = '<span class="imm-if__label">Brand</span>' + vendors.slice(0, 14).map(function (v) {
        return '<button type="button" class="imm-chip" data-brand="' + esc(v) + '" aria-pressed="false">' + esc(v) + ' <small>' + counts[v] + '</small></button>';
      }).join('') + (vendors.length > 14 ? '<select class="imm-chip imm-chip--sel" data-brand-more aria-label="More brands"><option value="">+' + (vendors.length - 14) + ' more brands</option>' +
        vendors.slice(14).map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + ' (' + counts[v] + ')</option>'; }).join('') + '</select>' : '');
    }
    // R14: product-type chips (Shopify product type from the index), only types with >= T_MIN products here
    var tc = {};
    data.forEach(function (p) { if (p[5]) tc[p[5]] = (tc[p[5]] || 0) + 1; });
    TYPES = Object.keys(tc).filter(function (t) { return tc[t] >= T_MIN; }).sort(function (a, b) { return tc[b] - tc[a] || (a < b ? -1 : 1); });
    state.types = state.types.filter(function (t) { return TYPES.indexOf(t) > -1; });
    if (TYPES.length > 1 && tWrap) {
      tWrap.innerHTML = '<span class="imm-if__label">Type</span>' + TYPES.slice(0, T_TOP).map(function (t) {
        return '<button type="button" class="imm-chip" data-type-chip="' + esc(t) + '" aria-pressed="false">' + esc(t) + ' <small>' + tc[t] + '</small></button>';
      }).join('') + (TYPES.length > T_TOP ? '<select class="imm-chip imm-chip--sel" data-type-more aria-label="More product types"></select>' : '');
      state.types.forEach(function (t) { if (TYPES.indexOf(t) >= T_TOP) addTypeChip(t); });
    } else state.types = [];
    pWrap.innerHTML = '<span class="imm-if__label">Price</span>' + BANDS.map(function (b, i) {
      var n = data.filter(function (p) { return p[3] >= b[1] && p[3] < b[2]; }).length;
      return n ? '<button type="button" class="imm-chip" data-band="' + i + '" aria-pressed="false">' + b[0] + ' <small>' + n + '</small></button>' : '';
    }).join('');
  }

  // R14: a pressed chip for a type picked from the "more types" select (or ?if_type=), placed first after the
  // label so it stays in view in the scrolling chip row at 390 px
  function addTypeChip(t) {
    var have = false;
    tWrap.querySelectorAll('[data-type-chip]').forEach(function (b) { if (b.getAttribute('data-type-chip') === t) have = true; });
    if (have) return;
    var html = '<button type="button" class="imm-chip" data-type-chip="' + esc(t) + '" aria-pressed="true">' + esc(t) + ' <small></small></button>';
    var lab = tWrap.querySelector('.imm-if__label');
    if (lab) lab.insertAdjacentHTML('afterend', html); else tWrap.insertAdjacentHTML('afterbegin', html);
    tWrap.scrollLeft = 0;
  }
  // R14: live counts on the type chips for the current brand / price / text set. A chip at 0 hides unless it is on;
  // the select lists the other types that still have products in that set.
  var lostFocus = false;
  function typeCounts(set) {
    if (!tWrap || TYPES.length < 2) return;
    var c = {}, chipT = [];
    set.forEach(function (p) { if (p[5]) c[p[5]] = (c[p[5]] || 0) + 1; });
    tWrap.querySelectorAll('[data-type-chip]').forEach(function (b) {
      var t = b.getAttribute('data-type-chip'), n = c[t] || 0;
      chipT.push(t);
      b.querySelector('small').textContent = n;
      var hide = !n && state.types.indexOf(t) === -1;
      if (hide && document.activeElement === b) lostFocus = true;   // R16: focus moves to Clear filters instead of body
      b.hidden = hide;
    });
    var sel = tWrap.querySelector('[data-type-more]');
    if (!sel) return;
    var rest = TYPES.filter(function (t) { return chipT.indexOf(t) === -1 && c[t]; });
    sel.hidden = !rest.length;
    sel.innerHTML = '<option value="">+' + rest.length + ' more type' + (rest.length === 1 ? '' : 's') + '</option>' +
      rest.map(function (t) { return '<option value="' + esc(t) + '">' + esc(t) + ' (' + c[t] + ')</option>'; }).join('');
  }

  function apply() {
    var active = state.q || state.brands.length || state.band > -1 || state.types.length;
    box.classList.toggle('is-active', !!active);
    bWrap.querySelectorAll('[data-brand]').forEach(function (b) { b.setAttribute('aria-pressed', String(state.brands.indexOf(b.getAttribute('data-brand')) > -1)); });
    pWrap.querySelectorAll('[data-band]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-band') === state.band)); });
    if (tWrap) tWrap.querySelectorAll('[data-type-chip]').forEach(function (b) { b.setAttribute('aria-pressed', String(state.types.indexOf(b.getAttribute('data-type-chip')) > -1)); });
    var toks = norm(state.q).split(' ').filter(Boolean), band = BANDS[state.band];
    // R14: brand / price / text first; the type chip counts come from that set (how many each type would show)
    var base = !active ? data : data.filter(function (p) {
      if (state.brands.length && state.brands.indexOf(p[2]) === -1) return false;
      if (band && !(p[3] >= band[1] && p[3] < band[2])) return false;
      if (toks.length) { if (window.immMatchQ) { if (!window.immMatchQ(p, state.q)) return false; } else { var h = norm(p[0] + ' ' + p[2] + ' ' + p[5] + ' ' + (p[6] || '')); for (var i = 0; i < toks.length; i++) if (h.indexOf(toks[i]) === -1) return false; } }
      return true;
    });
    typeCounts(base);
    if (!active) { server.hidden = false; res.hidden = true; status.innerHTML = ''; if (lostFocus) { lostFocus = false; qIn.focus(); } return; }
    var list = state.types.length ? base.filter(function (p) { return state.types.indexOf(p[5]) > -1; }) : base;
    status.innerHTML = '<b>' + list.length + '</b> of ' + data.length + ' products <button type="button" data-if-clear>Clear filters</button>';
    if (lostFocus) { lostFocus = false; status.querySelector('[data-if-clear]').focus(); }
    server.hidden = true; res.hidden = false;
    grid.innerHTML = list.slice(0, shown).map(function (p) {
      return '<article class="imm-card imm-prod" data-sku="' + esc(p[6]) + '" data-type="' + esc(p[5]) + '"><button type="button" class="imm-prod__cmp" data-imm-cmp aria-pressed="false" data-t="' + esc(p[0]) + '" data-u="/products/' + esc(p[1]) + '" data-i="' + esc(p[4]) + '" data-v="' + esc(p[2]) + '" data-p="' + Number(p[3]).toFixed(2) + '">Compare</button><div class="imm-prod__media">' +
        (p[4] ? '<img src="' + esc(p[4].replace('width=160', 'width=600')) + '" width="600" height="600" loading="lazy" alt="' + esc(p[0]) + '">' : '') +
        '</div><span class="imm-prod__brand">' + esc(p[2]) + '</span><h3 class="imm-prod__title"><a href="/products/' + esc(p[1]) + '">' + esc(p[0]) + '</a></h3>' +
        '<div class="imm-prod__price">' + money(p[3]) + ' <small class="imm-prod__cur">USD</small></div><div class="imm-prod__foot"><span class="imm-prod__stock"><i></i>' + 'Typical reply: 1 working day' + '</span>' +
        '<a class="imm-prod__quote" href="' + quoteUrl + '?product=' + encodeURIComponent(p[0]) + '" data-imm-qadd data-t="' + esc(p[0]) + '" data-u="/products/' + esc(p[1]) + '" data-i="' + esc(p[4]) + '" data-v="' + esc(p[2]) + '" data-p="' + Number(p[3]).toFixed(2) + '">+ Add to quote</a></div></article>';
    }).join('') || '<div class="imm-empty"><p>No products match. Send us the model and we quote it anyway.</p><a class="imm-btn imm-btn--primary" href="' + quoteUrl + '?product=' + encodeURIComponent(state.q || state.brands.join(', ')) + '">Request a quote</a></div>';
    more.hidden = list.length <= shown;
    more.textContent = 'Show more (' + (list.length - shown) + ' left)';
    if (window.immQuoteRender) window.immQuoteRender();
  }

  box.hidden = false;
  var started = false;
  try {
    var qp = new URLSearchParams(location.search);
    if (qp.has('if_band')) state.band = Math.max(-1, Math.min(3, parseInt(qp.get('if_band'), 10)));
    if (qp.get('if_brand')) state.brands = [qp.get('if_brand')];
    if (qp.get('if_type')) state.types = [qp.get('if_type')];
    if (qp.get('if_q')) { state.q = qp.get('if_q'); qIn.value = state.q; }
  } catch (e) {}
  function start() {
    if (started) return; started = true;
    status.textContent = 'Loading filters…';
    load().then(function () { status.textContent = ''; chips(); apply(); }, function () { status.textContent = ''; });
  }
  // Load once the visitor reaches the filter bar (or interacts), so first paint stays light
  if (state.band > -1 || state.brands.length || state.types.length || state.q) start();
  else if (url === '/collections/all') ['focusin', 'pointerenter', 'touchstart'].forEach(function (ev) { box.addEventListener(ev, start, { once: true, passive: true }); });
  else if ('IntersectionObserver' in window) new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { o.disconnect(); start(); } }).observe(box);
  else start();
  qIn.addEventListener('focus', start);
  qIn.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { state.q = qIn.value.trim(); shown = 48; if (data) apply(); }, 140); });
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-brand]'), p = e.target.closest('[data-band]'), tc = e.target.closest('[data-type-chip]');
    if (tc) { var tv = tc.getAttribute('data-type-chip'), ti = state.types.indexOf(tv); if (ti > -1) state.types.splice(ti, 1); else state.types.push(tv); }
    else if (b) { var v = b.getAttribute('data-brand'), i = state.brands.indexOf(v); if (i > -1) state.brands.splice(i, 1); else state.brands.push(v); }
    else if (p) { var n = +p.getAttribute('data-band'); state.band = state.band === n ? -1 : n; }
    else if (e.target.closest('[data-if-clear]')) {
      state = { q: '', brands: [], band: -1, types: [] }; qIn.value = '';
      // R16: chips promoted from the "more" selects go back into the selects
      if (tWrap) tWrap.querySelectorAll('[data-type-chip]').forEach(function (c) { if (TYPES.indexOf(c.getAttribute('data-type-chip')) >= T_TOP) c.remove(); });
      bWrap.querySelectorAll('[data-brand]').forEach(function (c) { if (!c.querySelector('small')) c.remove(); });
      shown = 48; apply(); if (e.detail === 0) qIn.focus(); return;   // R18: no mobile keyboard after a tap
    }
    else return;
    shown = 48; apply();
  });
  // R14 + R16: picking from a "more" select promotes the value to a pressed chip. Arrow / Home / End / Page keys only
  // browse (a closed select fires change on every arrow press); commit on Enter, a mouse/touch pick or blur.
  function commitSel(sel) {
    var v = sel.value; sel._kbd = false;
    if (!v) return;
    if (sel.matches('[data-type-more]')) {
      if (state.types.indexOf(v) === -1) state.types.push(v);
      addTypeChip(v);
      sel.value = '';
      shown = 48; apply();
      var nb = tWrap.querySelector('[data-type-more]');
      if (!nb || nb.hidden) { var pc = tWrap.querySelector('[data-type-chip][aria-pressed="true"]'); if (pc) pc.focus(); }
      return;
    }
    if (state.brands.indexOf(v) === -1) state.brands.push(v);
    sel.value = '';
    var have = false;
    bWrap.querySelectorAll('[data-brand]').forEach(function (c) { if (c.getAttribute('data-brand') === v) have = true; });
    if (!have) sel.insertAdjacentHTML('beforebegin', '<button type="button" class="imm-chip" data-brand="' + esc(v) + '" aria-pressed="true">' + esc(v) + '</button>');
    shown = 48; apply();
  }
  var SEL = '[data-type-more], [data-brand-more]';
  box.addEventListener('keydown', function (e) {
    if (!e.target.matches(SEL)) return;
    if (/^(Arrow(Up|Down|Left|Right)|Home|End|PageUp|PageDown)$/.test(e.key)) { e.target._kbd = true; e.target._kt = Date.now(); }
    else if (e.key === 'Enter') { e.preventDefault(); commitSel(e.target); }
  });
  box.addEventListener('pointerdown', function (e) { var t = e.target.closest(SEL); if (t) t._kbd = false; });
  box.addEventListener('change', function (e) {
    // R18: skip only a change that directly follows an arrow key (closed select); a popup pick commits at once
    if (!e.target.matches(SEL) || (e.target._kbd && Date.now() - (e.target._kt || 0) < 150)) return;
    commitSel(e.target);
  });
  box.addEventListener('focusout', function (e) {
    if (e.target.matches(SEL) && e.target._kbd) commitSel(e.target);
  });
  more.addEventListener('click', function () { shown += 48; apply(); });
})();

/* Loop 2 R12: non-critical features (recently viewed, exit prompt, compare) start when the browser is idle or on
   the first pointer/key/touch/wheel input, whichever comes first (pointerdown fires before click, so no tap is lost). */
window.immLater = (function () {
  var q = [], done = false, ev = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
  function run(f) { try { f(); } catch (e) { setTimeout(function () { throw e; }); } }
  function flush() {
    if (done) return; done = true;
    ev.forEach(function (n) { document.removeEventListener(n, flush, true); });
    while (q.length) run(q.shift());
  }
  ev.forEach(function (n) { document.addEventListener(n, flush, { capture: true, passive: true }); });
  if (window.requestIdleCallback) requestIdleCallback(flush, { timeout: 2000 }); else setTimeout(flush, 300);
  return function (f) { if (done) run(f); else q.push(f); };
})();

/* R10: recently viewed (localStorage imm_rv, newest first, max 12). R14: the SAVE runs at once (a quick bounce
   before idle still records the product); only the strip render waits for immLater. */
(function () {
  var KEY = 'imm_rv';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var cur = document.querySelector('[data-imm-rv-save]'), a = load();
  if (cur) {
    var u = cur.getAttribute('data-u');
    a = a.filter(function (x) { return x.u !== u; });
    a.unshift({ t: cur.getAttribute('data-t'), u: u, i: cur.getAttribute('data-i'), v: cur.getAttribute('data-v'), p: cur.getAttribute('data-p') });
    a = a.slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  window.immLater(function () {
    var sec = document.querySelector('[data-imm-rv]');
    if (!sec) return;
    var show = cur ? a.slice(1) : a;
    if (show.length < 1) return;
    sec.querySelector('[data-imm-rv-row]').innerHTML = show.map(function (x) {
      return '<a class="imm-rv__item" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" width="150" height="150" alt="" loading="lazy">' : '<span class="imm-rv__ph"></span>') +
        '<small>' + esc(x.v) + '</small><span>' + esc(x.t) + '</span>' + (x.p && window.immFmt ? '<b>' + window.immFmt(x.p) + '</b>' : '') + '</a>';
    }).join('');
    sec.hidden = false;
    sec.querySelector('[data-imm-rv-clear]').addEventListener('click', function () { try { localStorage.removeItem(KEY); } catch (e) {} sec.hidden = true; });
  });
})();

/* R11: hero LCD readout cycles through sample measurement values */
(function () {
  var el = document.querySelector('[data-imm-lcd]');
  if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var vals = el.getAttribute('data-values').split('|'), i = 0;
  setInterval(function () {
    i = (i + 1) % vals.length;
    var target = vals[i], n = 0;
    var t = setInterval(function () {
      n++;
      el.textContent = n < 6 ? target.replace(/[0-9]/g, function () { return Math.floor(Math.random() * 10); }) : target;
      if (n >= 6) clearInterval(t);
    }, 45);
  }, 2400);
})();

/* R12: instrument finder (homepage) */
(function () {
  var f = document.querySelector('[data-imm-finder]');
  if (!f) return;
  var BANDS = [[0, 500, 'under $500'], [500, 2000, '$500-$2,000'], [2000, 10000, '$2,000-$10,000'], [10000, 1e12, '$10,000+']];
  var step2 = f.querySelector('[data-imm-finder-step2]'), go = f.querySelector('[data-imm-finder-go]'), help = f.querySelector('[data-imm-finder-help]');
  var quoteUrl = help.getAttribute('href'), cache = {}, sel = { url: null, label: '', band: null };
  function idx(url) {
    if (cache[url]) return cache[url];
    if (url === '/collections/all' && window.immGetIndex) return (cache[url] = window.immGetIndex());
    cache[url] = window.immLoadIdx(url).then(function (r) { return r.d; }, function (e) { delete cache[url]; throw e; });
    return cache[url];
  }
  function update() {
    if (!sel.url) return;
    var b = sel.band;
    var need = 'Need: ' + sel.label + (b !== null && b > -1 ? ', budget ' + BANDS[b][2] + ' per unit' : '');
    help.href = quoteUrl + '?product=' + encodeURIComponent(need);
    go.removeAttribute('aria-disabled');
    go.href = sel.url + (b !== null && b > -1 ? '?if_band=' + b : '');
    go.textContent = 'Counting\u2026';
    idx(sel.url).then(function (d) {
      var n = (b === null || b < 0) ? d.length : d.filter(function (p) { return p[3] >= BANDS[b][0] && p[3] < BANDS[b][1]; }).length;
      go.textContent = n ? 'Show ' + n + ' instrument' + (n === 1 ? '' : 's') + ' \u2192' : 'No listed models in this range. Ask us \u2192';
      if (!n) go.href = help.href;
    }, function () { go.textContent = 'Show instruments \u2192'; });
  }
  f.addEventListener('click', function (e) {
    var o = e.target.closest('.imm-finder__opt');
    if (o) {
      var grp = o.parentNode;
      grp.querySelectorAll('.imm-finder__opt').forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
      if (o.hasAttribute('data-url')) { sel.url = o.getAttribute('data-url'); sel.label = o.getAttribute('data-label'); step2.disabled = false; f.classList.add('has-1'); }
      else sel.band = +o.getAttribute('data-band');
      update();
      return;
    }
    if (e.target.closest('[data-imm-finder-go]') && go.getAttribute('aria-disabled') === 'true') e.preventDefault();
  });
})();

/* R13: description jump links + printable spec sheet */
(function () {
  // Loop 2 R3: key specs "All N specifications" -> description tab + first spec table (#imm-specs)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-imm-ks-more]'); if (!a) return;
    var tab = document.getElementById('tab-desc'); if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
    var t = document.getElementById('imm-specs') || document.getElementById('panel-desc'); if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  var panel = document.getElementById('panel-desc'), toc = document.querySelector('[data-imm-toc]');
  if (panel && toc) {
    var hs = Array.prototype.slice.call(panel.querySelectorAll('h3'));
    if (hs.length > 1) {
      toc.innerHTML = hs.map(function (h, i) {
        var label = /specification/i.test(h.textContent) ? 'Specifications' : h.textContent.trim();
        if (label.length > 28) label = label.slice(0, 26) + '\u2026';
        h.id = h.id || 'd-' + i;
        return '<a href="#' + h.id + '">' + label.replace(/</g, '&lt;') + '</a>';
      }).join('');
      toc.hidden = false;
      toc.addEventListener('click', function (e) {
        var a = e.target.closest('a'); if (!a) return;
        var tab = document.getElementById('tab-desc'); if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
      });
    }
  }
  document.querySelectorAll('[data-imm-print]').forEach(function (b) {
    b.addEventListener('click', function () {
      var tab = document.getElementById('tab-desc'); if (tab) tab.click();
      document.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
      setTimeout(function () { window.print(); }, 150);
    });
  });
})();

/* R14: cart -> quote list */
(function () {
  var KEY = 'imm_quote';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  var btn = document.querySelector('[data-imm-cart2quote]'), src = document.querySelector('[data-imm-cart-items]');
  if (btn && src) btn.addEventListener('click', function () {
    var items = []; try { items = JSON.parse(src.textContent); } catch (e) {}
    var a = load();
    items.forEach(function (it) {
      var ex = a.filter(function (x) { return x.u === it.u; })[0];
      if (ex) ex.q = Math.max(ex.q || 1, it.q); else a.push(it);
    });
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    if (window.immQuoteRender) window.immQuoteRender();
    var open = document.querySelector('[data-imm-qopen]'); if (open) open.click();
  });
  var box = document.querySelector('[data-imm-cart-qlist]');
  if (box) { var n = load().length; if (n) { box.hidden = false; box.querySelector('[data-imm-qcount-cart]').textContent = n; } }
})();

/* R15: 404 rescue - guess the product from the dead URL's slug */
(function () {
  var box = document.querySelector('[data-imm-404]');
  if (!box || !window.immGetIndex || !window.immSearch) return;
  var slug = location.pathname.split('/').filter(Boolean).pop() || '';
  try { slug = decodeURIComponent(slug); } catch (e) {}
  var words = slug.replace(/\.(html?|php)$/, '').split(/[-_+ ]+/).filter(function (w) { return w.length > 1 && !/^(product|products|shop|the|and|for|with|price|buy)$/i.test(w); });
  if (!words.length) return;
  var input = document.querySelector('.imm-404 input[name="q"]');
  if (input && !input.value) input.value = words.slice(0, 4).join(' ');
  window.immGetIndex().then(function (d) {
    var r = { total: 0 };
    for (var n = Math.min(words.length, 4); n > 0 && !r.total; n--) r = window.immSearch(d, words.slice(0, n).join(' '), 4);
    if (!r.total) return;
    var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    box.querySelector('[data-imm-404-grid]').innerHTML = r.list.map(function (p) {
      return '<article class="imm-card imm-prod"><button type="button" class="imm-prod__cmp" data-imm-cmp aria-pressed="false" data-t="' + esc(p[0]) + '" data-u="/products/' + esc(p[1]) + '" data-i="' + esc(p[4]) + '" data-v="' + esc(p[2]) + '" data-p="' + Number(p[3]).toFixed(2) + '">Compare</button><div class="imm-prod__media">' + (p[4] ? '<img src="' + esc(p[4].replace('width=160', 'width=400')) + '" width="400" height="400" alt="" loading="lazy">' : '') +
        '</div><span class="imm-prod__brand">' + esc(p[2]) + '</span><h3 class="imm-prod__title"><a href="/products/' + esc(p[1]) + '">' + esc(p[0]) + '</a></h3>' +
        '<div class="imm-prod__price">' + window.immMoney(p[3]) + ' <small class="imm-prod__cur">USD</small></div></article>';
    }).join('');
    box.hidden = false;
  });
})();

/* R16: rotating announcement bar (pauses on hover/focus, respects reduced motion) */
(function () {
  var bar = document.querySelector('[data-imm-announce]');
  if (!bar) return;
  var msgs = bar.querySelectorAll('.imm-announce__msg');
  if (msgs.length < 2) return;
  var i = 0, paused = false;
  function show(n) {
    msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true');
    var a = msgs[i].querySelector('a'); if (a) a.tabIndex = -1;
    i = (n + msgs.length) % msgs.length;
    msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
    a = msgs[i].querySelector('a'); if (a) a.removeAttribute('tabindex');
  }
  bar.addEventListener('click', function (e) { var b = e.target.closest('[data-dir]'); if (b) show(i + (+b.getAttribute('data-dir'))); });
  bar.addEventListener('mouseenter', function () { paused = true; });
  bar.addEventListener('mouseleave', function () { paused = false; });
  bar.addEventListener('focusin', function () { paused = true; });
  bar.addEventListener('focusout', function () { paused = false; });
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(function () { if (!paused && !document.hidden) show(i + 1); }, (+bar.getAttribute('data-speed') || 5) * 1000);
})();

/* R17: FAQ side CTA jumps to the quote box (or the buy box) */
(function () {
  var a = document.querySelector('[data-imm-pbar-go2]');
  if (!a) return;
  a.addEventListener('click', function (e) {
    var t = document.getElementById('quote-box') || document.querySelector('.imm-buy');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    t.classList.remove('is-flash'); void t.offsetWidth; t.classList.add('is-flash');
    var f = t.querySelector('details.imm-qbox__more'); if (f) f.open = true;
    var n = t.querySelector('textarea, input[type=email]'); if (n) setTimeout(function () { n.focus({ preventScroll: true }); }, 450);
  });
})();

/* R18: exit-intent prompt. R14: the thanks toast after an exit-form post shows at once, not on idle. */
if (window.immPostedBy === 'exit') {   // submitter recorded by the R10b block
  setTimeout(function () { if (window.immToast) window.immToast('Thanks. We typically reply within one working day.'); }, 400);
}
window.immLater(function () {
  var ex = document.querySelector('[data-imm-exit]');
  if (!ex) return;
  var K = 'imm_exit_seen';
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return '1'; } }
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || window.innerWidth < 900) return;
  if (ss(K) === '1') return;
  var armed = false, last = null;
  setTimeout(function () { armed = true; }, 20000);
  function open() {
    if (!armed || ss(K) === '1') return;
    if (document.querySelector('.imm-qd.is-open') || document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    ss(K, '1'); last = document.activeElement;
    ex.hidden = false; requestAnimationFrame(function () { ex.classList.add('is-open'); });
    var f = ex.querySelector('input:not([type=hidden])'); if (f) f.focus();
  }
  function close() { ex.classList.remove('is-open'); setTimeout(function () { ex.hidden = true; }, 200); if (last && last.focus) last.focus(); }
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
  ex.addEventListener('click', function (e) { if (e.target.closest('[data-imm-exit-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ex.hidden) close(); });
});

/* R19: compare up to 3 products. Specs come from the first table in each product description. */
window.immLater(function () {
  var KEY = 'imm_cmp', MAX = 3;
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} render(); }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var tray = document.createElement('div');
  tray.className = 'imm-cmp-tray'; tray.hidden = true; tray.setAttribute('role', 'region'); tray.setAttribute('aria-label', 'Compare products');
  document.body.appendChild(tray);
  var modal = document.createElement('div');
  modal.className = 'imm-cmp'; modal.hidden = true;
  modal.innerHTML = '<div class="imm-cmp__scrim" data-cmp-close></div><div class="imm-cmp__panel" role="dialog" aria-modal="true" aria-label="Product comparison"><div class="imm-cmp__head"><b>Compare</b><label class="imm-cmp__diff"><input type="checkbox" data-cmp-diff> Only differences</label><button type="button" class="imm-qd__x" data-cmp-close aria-label="Close comparison">&times;</button></div><div class="imm-cmp__body" data-cmp-body></div></div>';
  document.body.appendChild(modal);

  function render() {
    var a = load();
    document.querySelectorAll('[data-imm-cmp]').forEach(function (b) {
      var on = a.some(function (x) { return x.u === b.getAttribute('data-u'); });
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? '✓ Comparing' : 'Compare';
    });
    tray.hidden = a.length === 0;
    document.body.classList.toggle('imm-cmp-on', a.length > 0);
    tray.innerHTML = '<div class="imm-cmp-tray__items">' + a.map(function (x, i) {
      return '<span class="imm-cmp-tray__it">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="36" height="36">' : '') + '<span>' + esc(x.t) + '</span><button type="button" data-cmp-rm="' + i + '" aria-label="Remove ' + esc(x.t) + '">&times;</button></span>';
    }).join('') + '</div><button type="button" class="imm-btn imm-btn--primary imm-btn--sm" data-cmp-open' + (a.length < 2 ? ' disabled' : '') + '>' + (a.length < 2 ? 'Add 1 more to compare' : 'Compare ' + a.length + ' →') + '</button>';
  }

  function specs(html) {
    var d = new DOMParser().parseFromString(html, 'text/html'), p = d.getElementById('panel-desc'), out = {};
    if (!p) return out;
    var t = p.querySelector('table');
    if (t) t.querySelectorAll('tr').forEach(function (r) {
      var c = r.querySelectorAll('th, td');
      if (c.length >= 2) { var k = c[0].textContent.trim(); if (k) out[k] = c[1].textContent.trim(); }
    });
    var feat = null;
    p.querySelectorAll('h3').forEach(function (h) { if (!feat && /feature/i.test(h.textContent)) feat = h.nextElementSibling; });
    if (feat && feat.tagName === 'UL') out['Key features'] = Array.prototype.map.call(feat.querySelectorAll('li'), function (li) { return li.textContent.trim(); }).slice(0, 5).join(' · ');
    var box = null;
    p.querySelectorAll('h3').forEach(function (h) { if (!box && /in the box/i.test(h.textContent)) box = h.nextElementSibling; });
    if (box && box.tagName === 'UL') out['In the box'] = Array.prototype.map.call(box.querySelectorAll('li'), function (li) { return li.textContent.trim(); }).join(' · ');
    return out;
  }

  var cmpLast = null;
  function openModal() {
    var a = load(); if (a.length < 2) return;
    cmpLast = document.activeElement;
    modal.hidden = false; document.documentElement.classList.add('imm-noscroll');
    var body = modal.querySelector('[data-cmp-body]');
    body.innerHTML = '<p class="imm-cmp__loading">Loading specifications…</p>';
    Promise.all(a.map(function (x) { return fetch(x.u).then(function (r) { return r.text(); }).then(specs, function () { return {}; }); })).then(function (all) {
      var keys = [];
      all.forEach(function (s) { Object.keys(s).forEach(function (k) { if (keys.indexOf(k) === -1 && k !== 'Key features' && k !== 'In the box') keys.push(k); }); });
      keys.push('Key features', 'In the box');
      var head = '<tr><th scope="col"></th>' + a.map(function (x) {
        return '<th scope="col"><a href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" width="90" height="90">' : '') + '<small>' + esc(x.v) + '</small>' + esc(x.t) + '</a>' +
          '<span class="imm-cmp__price">' + (x.p && window.immFmt ? window.immFmt(x.p) : '') + '</span></th>';
      }).join('') + '</tr>';
      var rows = keys.map(function (k) {
        var vals = all.map(function (s) { return s[k] || ''; });
        if (!vals.some(Boolean)) return '';
        var same = vals.every(function (v) { return v === vals[0]; });
        return '<tr class="' + (same ? 'is-same' : 'is-diff') + '"><th scope="row">' + esc(k) + '</th>' + vals.map(function (v) { return '<td>' + (v ? esc(v) : '<span class="imm-muted">&ndash;</span>') + '</td>'; }).join('') + '</tr>';
      }).join('');
      var foot = '<tr class="imm-cmp__foot"><th></th>' + a.map(function (x) {
        return '<td><button type="button" class="imm-btn imm-btn--primary imm-btn--sm imm-btn--block" data-imm-qadd data-t="' + esc(x.t) + '" data-u="' + esc(x.u) + '" data-i="' + esc(x.i) + '" data-v="' + esc(x.v) + '" data-p="' + esc(x.p) + '">+ Add to quote</button></td>';
      }).join('') + '</tr>';
      body.innerHTML = '<div class="imm-cmp__scroll"><table class="imm-cmp__table">' + head + rows + foot + '</table></div>' +
        (rows ? '' : '<p class="imm-cmp__loading">These listings have no spec table yet. Ask us for a side-by-side.</p>');
      if (window.immQuoteRender) window.immQuoteRender();
    });
    var x = modal.querySelector('.imm-qd__x'); if (x) x.focus();
  }
  function closeModal() { modal.hidden = true; document.documentElement.classList.remove('imm-noscroll'); if (cmpLast && cmpLast.focus) cmpLast.focus(); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-imm-cmp]');
    if (b) {
      e.preventDefault();
      var a = load(), u = b.getAttribute('data-u'), i = -1;
      a.forEach(function (x, n) { if (x.u === u) i = n; });
      if (i > -1) a.splice(i, 1);
      else { if (a.length >= MAX) a.shift(); a.push({ t: b.getAttribute('data-t'), u: u, i: b.getAttribute('data-i'), v: b.getAttribute('data-v'), p: b.getAttribute('data-p') }); }
      save(a); return;
    }
    var rm = e.target.closest('[data-cmp-rm]');
    if (rm) { var c = load(); c.splice(+rm.getAttribute('data-cmp-rm'), 1); save(c); return; }
    if (e.target.closest('[data-cmp-open]')) { openModal(); return; }
    if (e.target.closest('[data-cmp-close]')) closeModal();
  });
  modal.addEventListener('change', function (e) { if (e.target.matches('[data-cmp-diff]')) modal.classList.toggle('only-diff', e.target.checked); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  // JS-rendered grids (search fallback, instant filter) call this after they draw cards
  window.immCmpRender = render;
  var mo = new MutationObserver(function () { render(); });
  document.querySelectorAll('[data-imm-search-grid], [data-imm-if-grid]').forEach(function (g) { mo.observe(g, { childList: true }); });
  render();
});

/* 20b: keep Tab inside whichever modal dialog is open */
(function () {
  function openDialog() {
    return document.querySelector('.imm-cmp:not([hidden]) .imm-cmp__panel') || document.querySelector('.imm-exit.is-open .imm-exit__card') || document.querySelector('.imm-qd.is-open .imm-qd__panel');
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = openDialog(); if (!d) return;
    var f = Array.prototype.filter.call(d.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
    var tb = d.matches('.imm-qd__panel') && document.querySelector('.imm-toast.is-on [data-imm-qundo]');   // R16: undo toast stays reachable
    if (tb) { if (document.activeElement === tb) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); return; } f.push(tb); }
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
